module.exports = __webpack_public_path__ + "static/Concord-135b656a170e785d8c7dc167bd5789fd.jpg";